import { EventEmitter, Injectable } from '@angular/core';
import * as moment from 'moment';
import { TextKeys } from '../../i18n/text-keys';
import { AbsenceSelectionListComponent } from '../../../components/absence/absence-selection-list/absence-selection-list.component';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../modal.service';
import { AbsenceModalModel } from '../../models/absence/absence-modal.model';
import { AbsenceListItem } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class AbsenceSelectionService {
  constructor(
    private datePipe: DatePipe,
    private translate: TranslateService,
    private modalService: ModalService
  ) {}

  /**
   * Create Modal for ask for absence Selection.
   */
  createAskForAbsenceModal(): AbsenceModalModel {
    return this.createAbsenceModal(
      this.translate.instant(TextKeys.absence.reason)
    );
  }

  /**
   * Show Absence Modal
   */
  createAbsenceModal(title: string): AbsenceModalModel {
    const result = {} as AbsenceModalModel;
    result.onCancel = new EventEmitter<void>();
    result.onSave = new EventEmitter<AbsenceListItem>();
    result.overlay = this.modalService.showModalNew(
      AbsenceSelectionListComponent,
      {
        modalView: true,
        title,
        absenceSelected: result.onSave,
        cancelEvent: result.onCancel,
      }
    );
    return result;
  }

  /**
   * Create Modal for absence Selection with Range in Title.
   *
   * @param startDate
   * @param endDate
   */
  createNewAbsenceSelection(
    startDate: string,
    endDate: string
  ): AbsenceModalModel {
    const start = this.datePipe.transform(startDate, 'mediumDate');
    const end = this.datePipe.transform(endDate, 'mediumDate');
    let title = '';

    if (moment(startDate).diff(moment(endDate)) < 0) {
      title =
        this.translate.instant(TextKeys.absence.createNew) +
        start +
        ' - ' +
        end;
    } else {
      title = this.translate.instant(TextKeys.absence.createNew) + start;
    }

    return this.createAbsenceModal(title);
  }
}
